import React from "react";
import styles from "./AssessmentBackground.module.css";

/* Decorative-only layer: gradient blobs + abstract rings.
   aria-hidden so it never reaches assistive tech. */
const AssessmentBackground = () => (
  <div className={styles.bg} aria-hidden="true">
    <span className={`${styles.blob} ${styles.blobA}`} />
    <span className={`${styles.blob} ${styles.blobB}`} />
    <span className={`${styles.blob} ${styles.blobC}`} />
    <span className={`${styles.ring} ${styles.ringA}`} />
    <span className={`${styles.ring} ${styles.ringB}`} />
  </div>
);

export default AssessmentBackground;
